export enum ConfigurationVariant {
  allAboveToAllClients = '*All above configurations apply to all clients',
  theAboveToAllClients = '*The above configurations apply to all clients',
  allAboveToNonApiUsers = '*All above configurations apply to non API users',
  theAboveToNonApiUsers = '*The above configurations apply to non API users only',
}
